import type { ReactNode } from 'react';

/** Centered modal matching the original's .modal-bg / .modal markup. */
export function Modal({
  title,
  subtitle,
  children,
  onClose,
  footer,
  wide,
}: {
  title: string;
  subtitle?: string;
  children?: ReactNode;
  onClose: () => void;
  footer?: ReactNode;
  wide?: boolean;
}) {
  return (
    <div className="modal-bg show" onClick={onClose}>
      <div className={`modal${wide ? ' modal-lg' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="modal-scroll panel-pad">
          <h3 style={{ fontSize: 18, color: 'var(--navy)', marginBottom: subtitle ? 4 : 12 }}>
            {title}
          </h3>
          {subtitle && (
            <p style={{ color: 'var(--muted)', fontSize: 14, marginBottom: 14 }}>{subtitle}</p>
          )}
          {children}
        </div>
        {footer && <div className="modal-foot">{footer}</div>}
      </div>
    </div>
  );
}
